import type { ITwoFactorRepository } from '../../domain/ports';
import { twoFactorApi } from '../api';
import type {
  Activate2FAData,
  Activation2FAResult,
  Deactivate2FAData,
  Generate2FASecretData,
  Secret2FAResult,
  ApiResponse,
} from '../../application/dto/dtos';

/**
 * Adapte twoFactorApi vers le port ITwoFactorRepository.
 */
export class TwoFactorRepository implements ITwoFactorRepository {
  activate(data: Activate2FAData): Promise<ApiResponse<Activation2FAResult>> {
    return twoFactorApi.activate(data);
  }

  deactivate(data: Deactivate2FAData): Promise<ApiResponse<void>> {
    return twoFactorApi.deactivate(data);
  }

  generateSecret(data: Generate2FASecretData): Promise<ApiResponse<Secret2FAResult>> {
    return twoFactorApi.generateSecret(data);
  }

  sendCode(idUtilisateur: string): Promise<ApiResponse<{ expiresIn: number }>> {
    return twoFactorApi.sendCode(idUtilisateur);
  }

  verifyBackupCode(data: { idUtilisateur: string; code: string }): Promise<ApiResponse<{ codeValide: boolean }>> {
    return twoFactorApi.verifyBackupCode(data);
  }
}
